export const MOODS_EMOJI = {
  happy: '😊',
  thoughtful: '🤔',
  calm: '😌',
  energetic: '⚡',
  melancholic: '🌧️',
  curious: '🔍',
  playful: '🎨',
  contemplative: '🌙'
};

export const THEMES = [
  // ☀️ LIGHT GROUP (called "feminine" in design discussions — bright, soft, airy)
  { id: 'aura-soft', name: 'Aura Soft', description: 'Dreamy pastels', colors: ['#93c5fd', '#c084fc', '#f9a8d4'], emoji: '🌸', group: 'light' },
  { id: 'cherry-blossom', name: 'Cherry Blossom', description: 'Soft & romantic', colors: ['#fb7185', '#f472b6', '#fda4af'], emoji: '🌸', group: 'light' },
  { id: 'sunset', name: 'Sunset Glow', description: 'Warm & golden', colors: ['#f97316', '#ec4899', '#fbbf24'], emoji: '🌅', group: 'light' },
  { id: 'peach-cream', name: 'Peach Cream', description: 'Honey & blush', colors: ['#fed7aa', '#fbcfe8', '#fde68a'], emoji: '🍑', group: 'light' },
  { id: 'lavender-haze', name: 'Lavender Haze', description: 'Quiet purples', colors: ['#ddd6fe', '#c4b5fd', '#a78bfa'], emoji: '💜', group: 'light' },
  { id: 'rose-gold', name: 'Rose Gold', description: 'Soft luxury', colors: ['#fda4af', '#fcd34d', '#fb7185'], emoji: '🌹', group: 'light' },

  // 🌑 DARK GROUP (called "masculine" in design discussions — deep, neon, moody)
  { id: 'cyberpunk', name: 'Cyberpunk', description: 'Neon nights', colors: ['#00f0ff', '#ff00ff', '#39ff14'], emoji: '⚡', group: 'dark' },
  { id: 'cosmic', name: 'Cosmic Dust', description: 'Galactic mystery', colors: ['#8b5cf6', '#6366f1', '#a855f7'], emoji: '🌌', group: 'dark' },
  { id: 'midnight-aurora', name: 'Midnight Aurora', description: 'Northern lights', colors: ['#10b981', '#3b82f6', '#8b5cf6'], emoji: '🌠', group: 'dark' },
  { id: 'blood-moon', name: 'Blood Moon', description: 'Deep crimson', colors: ['#7f1d1d', '#dc2626', '#000000'], emoji: '🌑', group: 'dark' },
  { id: 'obsidian', name: 'Obsidian', description: 'Volcanic edge', colors: ['#18181b', '#3f3f46', '#71717a'], emoji: '🪨', group: 'dark' },
  { id: 'midnight-storm', name: 'Midnight Storm', description: 'Electric blue', colors: ['#1e1b4b', '#3b82f6', '#60a5fa'], emoji: '⛈️', group: 'dark' },

  // 🌫️ NEUTRAL GROUP (balanced — works for anyone)
  { id: 'ocean', name: 'Ocean Depths', description: 'Deep & serene', colors: ['#0ea5e9', '#06b6d4', '#22d3ee'], emoji: '🌊', group: 'neutral' },
  { id: 'forest', name: 'Forest Whisper', description: 'Natural calm', colors: ['#22c55e', '#84cc16', '#10b981'], emoji: '🌲', group: 'neutral' },
  { id: 'desert-sage', name: 'Desert Sage', description: 'Warm earth', colors: ['#84cc16', '#a3a3a3', '#d97706'], emoji: '🌵', group: 'neutral' },
  { id: 'stone-quartz', name: 'Stone Quartz', description: 'Cool minerals', colors: ['#a8a29e', '#e7e5e4', '#d6d3d1'], emoji: '🪨', group: 'neutral' },
  { id: 'mist-morning', name: 'Misty Morning', description: 'Soft fog', colors: ['#cbd5e1', '#94a3b8', '#e2e8f0'], emoji: '🌫️', group: 'neutral' },
];

// Theme group metadata — extensible (add more groups later w/o code changes elsewhere)
export const THEME_GROUPS = [
  { id: 'light', label: 'Light', emoji: '☀️', tagline: 'bright, soft, airy' },
  { id: 'dark', label: 'Dark', emoji: '🌑', tagline: 'deep, neon, moody' },
  { id: 'neutral', label: 'Neutral', emoji: '🌫️', tagline: 'balanced, anyone' },
];
